import $ from 'jquery';
import debounce from 'lodash/debounce';

class CaseHeader {
    constructor(speed) {
        this.speed = speed;
        this.$body = $('body');
        this.$window = $(window);

        this.fullHDratio = 1920 / 1000;
        this.veryFlatRatio = 1920 / 936;
        this.superFlatRatio = 1920 / 914;

        this.events();
    }

    events() {
        this.$window.on('resize', debounce(this.getRatio.bind(this), 40));

        this.getRatio();
    }

    getRatio() {
        let viewportWidth = this.$window.outerWidth(),
            viewportHeight = this.$window.outerHeight(),
            ratio = viewportWidth / viewportHeight;

        this.$body.toggleClass('flat-header', ratio > this.fullHDratio);
        this.$body.toggleClass('very-flat-header', ratio > this.veryFlatRatio);
        this.$body.toggleClass('super-flat-header', ratio > this.superFlatRatio);
    }
}

export default CaseHeader;



// WEBPACK FOOTER //
// ./sources/js/components/case-header.js